import React, {useEffect, useMemo, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import PeopleIcon from '@material-ui/icons/People';

//import table components
import AccidentsEnhancedTable from "./AccidentClientsTableComponent/EnhancedTable";
import CssBaseline from "@material-ui/core/CssBaseline";
import AgentService from "../../../services/AgentService";
import Spinner from "reactjs-simple-spinner";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
    },
    indicator: {
        color: "#00B2A9"
    }
}));

const AgentClients = () => {

    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [accData, setAccData] = useState([]);
    const [agent, setAgent] = useState({});

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const accColumns = useMemo(
        () => [
            {
                Header: 'Policy Number',
                accessor: 'policy_number',
            },
            {
                Header: 'Policy Type',
                accessor: 'policy_type',
            },
            {
                Header: 'Assured Name',
                accessor: 'first_name',
            },
            {
                Header: 'Assured Surname',
                accessor: 'last_name',
            },
            {
                Header: 'Sum Assured',
                accessor: 'sum_assured',
            },
            {
                Header: 'Premium',
                accessor: 'premium',
            },
            {
                Header: 'Commencement Date',
                accessor: 'commencement_date'
            },
            {
                Header: 'Status',
                accessor: 'policy_status'
            },

        ],
        []
    )


    const [skipPageReset, setSkipPageReset] = useState(false)

    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setAccData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    const [loading, setLoading] = useState(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true);
        const id = JSON.parse(localStorage.getItem('agentId'));
        console.log("id: ", id);
        //getAgentDetails
        AgentService.getAgentDetails(id)
            .then(res => {
                console.log("agent:", res);
                setAgent(res.data.agent);
                //get accClients
                AgentService.getAgentClients(id)
                    .then(res => {
                        console.log("ACCDATA: ", res.policyHolders);
                        setAccData(res.policyHolders);
                        setLoading(false)
                    }).catch(err => {
                    console.log(err);
                    setLoading(false)
                });
            }).catch(err => {
            console.log(err);
            setLoading(false)
        });




    }, []);

    return (
        <div>
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                             &nbsp;|&nbsp;
                            <Link to="/agents"><i className="fa fa-users"/> &nbsp;<a href>Sales Army</a>
                            </Link>
                             &nbsp;|&nbsp;
                            <span className="text-uppercase">{agent.name}&nbsp;{agent.surname}</span>

                        </ul>
                        <div className="row mt">
                            <div className="col-lg-12">
                                <Paper className={classes.root}>
                                    <Tabs value={value}
                                          onChange={handleChange}
                                          indicatorColor="primary"
                                          textColor="primary"
                                          centered
                                    >
                                        <Tab icon={<PeopleIcon/>} label="Agent Clients" {...a11yProps(0)} />
                                    </Tabs>
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Loading Clients..."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {!loading && (
                                        <TabPanel value={value} index={0}>
                                            <div id="table">
                                                <CssBaseline/>
                                                <AccidentsEnhancedTable
                                                    columns={accColumns}
                                                    data={accData}
                                                    setData={setAccData}
                                                    updateMyData={updateMyData}
                                                    skipPageReset={skipPageReset}
                                                />
                                            </div>
                                        </TabPanel>
                                    )}
                                </Paper>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AgentClients;
